import {inject, Injectable} from '@angular/core';
import {MatFormFieldAppearance} from '@angular/material/form-field';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {concatMap, filter, take, map, tap} from 'rxjs/operators';
import { TRANSLATE_PATH as TRANSLATE_PATH_PROJECT } from '../project.model';
import { TRANSLATE_PATH as TRANSLATE_PATH_SHARED } from 'src/app/shared/shared.model';
import {ProjectOpenapiCastService} from 'build/project/openapi-cast/project/project-openapi-cast.service';
import {IIdentifier, IQuestionIdentifier, PayloadSendData, ResponseLoadBankamountData, ResponseLoadQuestionContent, ResponseLoadQuestionContentArray, ResponseLoadQuestionList} from 'build/project/openapi-cast/project/project-openapi-cast.model';
import {ResponseAffected} from 'build/project/openapi-cast/shared/shared-openapi-cast.model';
import {IAllQuestion} from '../components/field-item-row/row.model';
import {FIELD_DESIGN_MODE, IMetaContent, ITEMTYPE} from 'src/app/shared/components/field-item/field-item.model';
import {TranslateDesignPipe} from 'src/app/shared/pipes/translate-design/translate-design.pipe';

export type FieldtypesToSend = { checkbox: boolean, combofield: boolean, date: boolean, divider: boolean, email: boolean, number: boolean, radio: boolean, rating: boolean, text: boolean, text_input: boolean, textarea: boolean, title_one: boolean, title_second: boolean, toggle: boolean };

@Injectable({
   providedIn: 'root'
})
export class MergeQuestiondataService {

   public sProjectOpenapi = inject(ProjectOpenapiCastService);
   public pTranslateDesign: TranslateDesignPipe = inject(TranslateDesignPipe);

   public subtitle?: string = "";
   private viewMode_: string = "";
   private fieldViewMode_: MatFormFieldAppearance = "fill";
   private fieldtypesToSend: FieldtypesToSend = {checkbox: false, combofield: false, date: false, divider: false, email: false, number: false, radio: false, rating: false, text: false, text_input: false, textarea: false, title_one: false, title_second: false, toggle: false};
   private resultLoadQuestionContent_: BehaviorSubject<ResponseLoadQuestionContentArray[]> = new BehaviorSubject<ResponseLoadQuestionContentArray[]>([]);
   public resultLoadQuestionContent$: Observable<ResponseLoadQuestionContentArray[]> = this.resultLoadQuestionContent_.asObservable();
   private resultLoadQuestionContent: ResponseLoadQuestionContentArray[] = [] as ResponseLoadQuestionContentArray[];
   private toggleContent: ResponseLoadQuestionContent = {} as ResponseLoadQuestionContent;
   private downloadContent: ResponseLoadQuestionContent = {} as ResponseLoadQuestionContent;
   private linkContent: ResponseLoadQuestionContent = {} as ResponseLoadQuestionContent;

   get viewMode (): string {
      return this.viewMode_;
   }

   get fieldViewMode (): MatFormFieldAppearance {
      return this.fieldViewMode_;
   }

   public loadData (_identifier: IIdentifier): Observable<IAllQuestion[]> {
    
      const res: string = this.pTranslateDesign.transform(TRANSLATE_PATH_PROJECT.QUESTION_FIELDTYPESTOBESEND);
      res.split(";").forEach(item => {
         this.fieldtypesToSend[item as keyof FieldtypesToSend] = true;
      });

      const fieldMode = this.pTranslateDesign.transform(TRANSLATE_PATH_SHARED.FIELDMODE);
      fieldMode && fieldMode != "" && fieldMode != TRANSLATE_PATH_SHARED.FIELDMODE ? this.fieldViewMode_ = Object.keys(FIELD_DESIGN_MODE)[Object.keys(FIELD_DESIGN_MODE).findIndex(elem => elem.toLowerCase() == FIELD_DESIGN_MODE[Number(fieldMode) ?? 0].toLowerCase())].toLowerCase() as MatFormFieldAppearance : ""

      this.setToggle(TRANSLATE_PATH_SHARED.FIELD_ITEMS + TRANSLATE_PATH_SHARED.FIELD_ITEMS_TOGGLE);
      this.setDownloadButton(TRANSLATE_PATH_SHARED.FIELD_ITEMS + TRANSLATE_PATH_SHARED.FIELD_ITEMS_DOWNLOAD_LINK);
      this.setLinkButton(TRANSLATE_PATH_SHARED.FIELD_ITEMS + TRANSLATE_PATH_SHARED.FIELD_ITEMS_LINK_BUTTON); 

      return this.sProjectOpenapi.loadQuestionList().pipe(
         map(data => this.mergeQuestionData(data))
      );

   }

   /*
   Aufgrund des Mapping geht die Funktion nicht kürzer: Yvonne hat ja gesagt
   */
   private mergeQuestionData (questionData: ResponseLoadQuestionList): IAllQuestion[] {
      const result: IAllQuestion[] = [] as IAllQuestion[];
      
      let responseAllocationQuestion: IAllQuestion = {} as IAllQuestion;
      let responseLoadQuestionContent: ResponseLoadQuestionContent = {} as ResponseLoadQuestionContent;

      let oldNr: string = "-1";

      Object.keys(questionData)
         .forEach(key => {
            const var_nr: string[] = key.split("_");

            if (var_nr[1] && var_nr[1] !== oldNr) {
               if (oldNr !== "-1" && responseAllocationQuestion.question_id !== "-1" && responseLoadQuestionContent.fieldtype !== "-1") {
                  responseAllocationQuestion.sort = +oldNr;
                  !(responseAllocationQuestion.dependsType) && responseAllocationQuestion.dependsQuestion ? responseAllocationQuestion.dependsType = "valid" : "";
                  result.push(responseAllocationQuestion);
                  this.resultLoadQuestionContent.push({question_id: responseAllocationQuestion.question_id, responseLoadQuestionContent: responseLoadQuestionContent});
               }
               oldNr = var_nr[1];
               responseAllocationQuestion = {} as IAllQuestion;
               responseLoadQuestionContent = {} as ResponseLoadQuestionContent;
            }

            // derzeit gibt es kein required für einzelne Felder
            switch (var_nr[0]) {
               case "textcode":
                  responseAllocationQuestion.question_id = questionData[key as keyof ResponseLoadQuestionList] as string ?? "";
                  break;
               case "text":
                  responseLoadQuestionContent.description = questionData[key as keyof ResponseLoadQuestionList] as string ?? "";
                  break;
               case "fieldtype":
                  responseLoadQuestionContent.fieldtype = questionData[key as keyof ResponseLoadQuestionList] as string ?? "";
                  responseAllocationQuestion.fieldtype = questionData[key as keyof ResponseLoadQuestionList] as ITEMTYPE ?? "";
                  responseLoadQuestionContent.send = this.fieldtypesToSend[responseLoadQuestionContent.fieldtype as keyof FieldtypesToSend];
                  responseLoadQuestionContent.fieldtype === ITEMTYPE.toggle ? responseLoadQuestionContent = {...this.toggleContent, send: responseLoadQuestionContent.send, description: responseLoadQuestionContent.description} : "";
                  responseLoadQuestionContent.fieldtype === ITEMTYPE.download ? responseLoadQuestionContent = {...this.downloadContent, send: responseLoadQuestionContent.send, description: responseLoadQuestionContent.description} : "";
                  responseLoadQuestionContent.fieldtype === ITEMTYPE.link ? responseLoadQuestionContent = {...this.linkContent, send: responseLoadQuestionContent.send, description: responseLoadQuestionContent.description} : "";
                  break;
               case "depends":
                  responseAllocationQuestion.dependsQuestion = questionData[key as keyof ResponseLoadQuestionList] as string ?? "";
                  break;
               case "dependstype":
                  responseAllocationQuestion.dependsType = questionData[key as keyof ResponseLoadQuestionList] as string ?? "";
                  break;
               case "dependsoption":
                  responseAllocationQuestion.dependsOption = questionData[key as keyof ResponseLoadQuestionList] as string ?? "";
                  break;
               default:
                  break;
            }

            key === "subtitle" ? this.subtitle =  questionData[key] : "";
         });

      if (oldNr !== "-1" && responseAllocationQuestion.question_id !== "-1" && responseAllocationQuestion.question_id !== ""  && responseLoadQuestionContent.fieldtype !== "-1") {
         responseAllocationQuestion.sort = +oldNr;

         !(responseAllocationQuestion.dependsType) && responseAllocationQuestion.dependsQuestion ? responseAllocationQuestion.dependsType = "valid" : "";

         this.resultLoadQuestionContent.push({question_id: responseAllocationQuestion.question_id, responseLoadQuestionContent: responseLoadQuestionContent});
         result.push(responseAllocationQuestion);
   
        
      }

      this.resultLoadQuestionContent_.next(this.resultLoadQuestionContent.filter(item => item.question_id !== ""));
      
      return result.filter(item => item.question_id !== '');
   }

   public setResultLoadQuestionContent (value: ResponseLoadQuestionContentArray): void {
      const result: ResponseLoadQuestionContentArray[] = [] as ResponseLoadQuestionContentArray[];
      result.push(value);
      this.resultLoadQuestionContent_.next(result);
   }

   public loadQuestionMetaData (identifier: IQuestionIdentifier): Observable<ResponseLoadQuestionContent> {
      if (identifier.question_id === "identificationtoggle") {
         return this.resultLoadQuestionContent$.pipe(
            map((items: ResponseLoadQuestionContentArray[]) => items.filter(item => item.question_id === identifier.question_id)),
            take(1),
            filter((items: ResponseLoadQuestionContentArray[]) => items && items.length > 0),
            concatMap((result: ResponseLoadQuestionContentArray[]) => of(result[0].responseLoadQuestionContent))
         );
      } else {
         return this.sProjectOpenapi.loadQuestionMetaData(identifier);
      }
   }

   public loadBankamountData (_identifier: IIdentifier): Observable<ResponseLoadBankamountData> {
      return this.sProjectOpenapi.loadBankamountData().pipe(
         map((bankamountData: ResponseLoadBankamountData) => {
               return bankamountData ? this.mergeBankAmountData(bankamountData && bankamountData.textcodeAmount == "-1" ? {...bankamountData, textcodeAmount: ""} : bankamountData) : {} as ResponseLoadBankamountData;
         })
      );
   }

   private mergeBankAmountData (bankamountData: ResponseLoadBankamountData): ResponseLoadBankamountData {
      this.setToggle(TRANSLATE_PATH_PROJECT.BANKAMOUNT_TOGGLE_BUTTON);
      this.toggleContent.description = bankamountData.textcodeAmount;
      this.resultLoadQuestionContent.push({question_id: "bankAmountToggle", responseLoadQuestionContent: this.toggleContent})
      this.resultLoadQuestionContent_.next(this.resultLoadQuestionContent)

      return bankamountData; 
   }

   public sendData (identifier: IIdentifier, value: IMetaContent[]): Observable<ResponseAffected> {
      return of(value).pipe(
         map(value => this.generatePayload(identifier, value)),
         concatMap((payload: PayloadSendData) => this.sProjectOpenapi.sendData(identifier.code, payload))
      );
   }

   private generatePayload (identifier: IIdentifier, value: IMetaContent[]): PayloadSendData {
      const payload: PayloadSendData = {} as PayloadSendData;
      payload.birthday = identifier.birthday;

      value.forEach((item: IMetaContent, index) => {
         if (item.question_id === "bankAmountToggle") {
            payload["textcodeAmount"] = item.question_id;
            payload["inputAmount"] = <string>item.content;
         } else {
            payload[("textcode_" + (index + 1)) as keyof typeof payload] = item.question_id;
            payload[("input_" + (index + 1)) as keyof typeof payload] = <string>item.content;
         }
      });

      return payload;
   }

   private setToggle (path: string): void {
      this.toggleContent.required = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.FIELD_ITEMS_REQUIRED);
      this.toggleContent.valid = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.FIELD_ITEMS_VALID);
      this.toggleContent.description = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.FIELD_ITEMS_DESCRIPTION);
      this.toggleContent.attribute_1 = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.FIELD_ITEMS_ATTRIBUTE_1);
      this.toggleContent.attribute_2 = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.FIELD_ITEMS_ATTRIBUTE_2); 
      this.toggleContent.attribute_3 = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.FIELD_ITEMS_ATTRIBUTE_3); 
      this.toggleContent.attribute_4 = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.FIELD_ITEMS_ATTRIBUTE_4); 
      this.toggleContent.attribute_5 = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.FIELD_ITEMS_ATTRIBUTE_5); 
      this.toggleContent.fieldtype = ITEMTYPE.toggle;
   }



   private setDownloadButton (path: string): void { 
      let res = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.DEFAULT_COLOR);
      res ? res === path + TRANSLATE_PATH_SHARED.DEFAULT_COLOR ? "" : this.downloadContent.attribute_1 = "default:" + res + ";" : "";

      res = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.SUCCESS_COLOR);
      res ? res === path + TRANSLATE_PATH_SHARED.SUCCESS_COLOR ? "" : this.downloadContent.attribute_1 = this.downloadContent.attribute_1 + "done:" + res : "";

      res = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.DEFAULT_ICON);
      res ? res === path + TRANSLATE_PATH_SHARED.DEFAULT_ICON ? "" : this.downloadContent.attribute_3 = "default:" + res + ";" : "";
      
      res = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.SUCCESS_ICON);
      res ? res === path + TRANSLATE_PATH_SHARED.SUCCESS_ICON ? "" : this.downloadContent.attribute_3 = this.downloadContent.attribute_3 + "done:" + res : "";

      res = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.FIELD_ITEMS_LABEL);
      res ? res === path + TRANSLATE_PATH_SHARED.FIELD_ITEMS_LABEL ? "" : this.downloadContent.attribute_6 = res : "";

      res = this.pTranslateDesign.transform(TRANSLATE_PATH_PROJECT.FIELD_ITEMS_PATH_PROJECT + TRANSLATE_PATH_PROJECT.FIELD_ITEMS_HREF);
      res ? res === path + TRANSLATE_PATH_PROJECT.FIELD_ITEMS_HREF ? "" : this.downloadContent.attribute_4 = res : "";

      res = this.pTranslateDesign.transform(path + TRANSLATE_PATH_PROJECT.FIELD_ITEMS_FILENAME);
      res ? res === path + TRANSLATE_PATH_PROJECT.FIELD_ITEMS_FILENAME ? "" : this.downloadContent.attribute_2 = res : "";

      this.downloadContent.fieldtype = ITEMTYPE.download;
   }

  
   private setLinkButton (path: string): void {
      
      let res = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.DEFAULT_COLOR);
      res ? res === path + TRANSLATE_PATH_SHARED.DEFAULT_COLOR ? "" : this.linkContent.attribute_1 = "default:" + res + ";" : "";

      res = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.SUCCESS_COLOR);
      res ? res === path + TRANSLATE_PATH_SHARED.SUCCESS_COLOR ? "" : this.linkContent.attribute_1 = this.linkContent.attribute_1 + "done:" + res : "";

      res = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.DEFAULT_ICON);
      res ? res === path + TRANSLATE_PATH_SHARED.DEFAULT_ICON ? "" : this.linkContent.attribute_3 = "default:" + res + ";" : "";

      res = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.SUCCESS_ICON);
      res ? res === path + TRANSLATE_PATH_SHARED.SUCCESS_ICON ? "" : this.linkContent.attribute_3 = this.linkContent.attribute_3 + "done:" + res : "";

      res = this.pTranslateDesign.transform(path + TRANSLATE_PATH_SHARED.FIELD_ITEMS_LABEL);
      res ? res === path + TRANSLATE_PATH_SHARED.FIELD_ITEMS_LABEL ? "" : this.linkContent.attribute_6 = res : "";

      res = this.pTranslateDesign.transform(TRANSLATE_PATH_PROJECT.FIELD_ITEMS_PATH_PROJECT + TRANSLATE_PATH_PROJECT.FIELD_ITEMS_HREF);
      res ? res === path + TRANSLATE_PATH_PROJECT.FIELD_ITEMS_HREF ? "" : this.linkContent.attribute_4 = res : "";

      this.linkContent.fieldtype = ITEMTYPE.link;
   }
}
